<template>
  <v-card class="pdf-viewer">
    <v-card-text class="d-flex flex-column flex-grow-1 overflow-y-auto pdf-viewer-container">
      <pdf :src="src" v-if="showPdf" :page="currentPage" class="pdf-viewer-pdf"></pdf>
      <span class="pdf-viewer-page-count">
        {{ currentPage }} / {{ totalPage }}
      </span>
      <v-btn class="pdf-viewer-prev-btn" icon key="pdf-viewer-prev-btn"
             v-if="currentPage !== 1 && totalPage !== 1"
             @click="currentPage -= 1">
        <v-icon>fas fa-chevron-circle-left</v-icon>
      </v-btn>

      <v-btn class="pdf-viewer-next-btn" icon key="pdf-viewer-next-btn"
             v-if="currentPage !== totalPage && totalPage !== 1"
             @click="currentPage += 1">
        <v-icon>fas fa-chevron-circle-right</v-icon>
      </v-btn>

      <v-btn class="pdf-viewer-download-btn" icon key="pdf-viewer-download-btn"
             @click="download">
        <v-icon color="white">mdi-download</v-icon>
      </v-btn>
    </v-card-text>
  </v-card>


  <!--  <v-dialog v-model="dialogShown"-->
  <!--            persistent-->
  <!--            @click:outside="onClose"-->
  <!--            max-width="600px">-->
  <!--    <v-container fluid class="pdf-viewer-container">-->
  <!--      <pdf :src="src" v-if="showPdf" :page="currentPage" class="pdf-viewer-pdf"></pdf>-->
  <!--      <span class="pdf-viewer-page-count">-->
  <!--        {{ currentPage }} / {{ totalPage }}-->
  <!--      </span>-->
  <!--      <span class="pdf-viewer-download-btn"-->
  <!--            v-if="fileId">-->
  <!--        <v-btn icon key="pdf-viewer-download-btn"-->
  <!--               @click="$downloadFile(fileId)">-->
  <!--        <v-icon>fas fa-download</v-icon>-->
  <!--      </v-btn>-->
  <!--      </span>-->
  <!--      <v-btn class="pdf-viewer-prev-btn" icon key="pdf-viewer-prev-btn"-->
  <!--             v-if="currentPage !== 1 && totalPage !== 1"-->
  <!--             @click="currentPage -= 1">-->
  <!--        <v-icon>fas fa-chevron-circle-left</v-icon>-->
  <!--      </v-btn>-->

  <!--      <v-btn class="pdf-viewer-next-btn" icon key="pdf-viewer-next-btn"-->
  <!--             v-if="currentPage !== totalPage && totalPage !== 1"-->
  <!--             @click="currentPage += 1">-->
  <!--        <v-icon>fas fa-chevron-circle-right</v-icon>-->
  <!--      </v-btn>-->
  <!--    </v-container>-->
  <!--  </v-dialog>-->
</template>

<script>
import {onMounted, ref} from '@vue/composition-api'
import pdf from 'vue-pdf'
import {ACTION_TYPES} from "@/store/types";

export default {
  name: 'PdfViewer',
  components: {pdf},
  props: {
    src: String,
    pageNo: {
      type: Number,
      default() {
        return 1;
      },
    },
  },
  setup(props, {root, emit}) {
    const currentPage = ref(0);
    const totalPage = ref(0);
    const showPdf = ref(false);

    const download = async function () {
      const path = props.src.replaceAll('/api', '');

      let response = await this.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: path,
        params: {},
        opt: {extra: {responseType: 'arraybuffer'}},
      });

      let blob = new Blob([response.data], {type: response.headers.get('content-type')});
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = decodeURI(response.headers.get('content-filename'));
      link.click();
    }

    onMounted(async () => {
      const p = await pdf.createLoadingTask(props.src).promise;
      currentPage.value = props.pageNo;
      totalPage.value = p.numPages;
      showPdf.value = true;
    })

    return {
      showPdf,
      currentPage,
      totalPage,

      download,
    }
  }
}
</script>

<style lang="less">
.pdf-viewer-container {
  background-color: white;
  position: relative;
  overflow: hidden;

  .pdf-viewer-pdf {
    max-height: 90vh;
    overflow-y: scroll;
  }

  .pdf-viewer-page-count, .pdf-viewer-download-btn {
    position: absolute;
    top: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 10px;
    border-radius: 50px;
    color: white;
  }

  .pdf-viewer-page-count {
    left: 50%;
    transform: translateX(-50%);
  }

  .pdf-viewer-download-btn {
    .v-btn {
      color: white;
    }
  }

  .pdf-viewer-prev-btn, .pdf-viewer-next-btn {
    position: absolute;
    top: 50%;
    font-size: 200%;
  }

  .pdf-viewer-prev-btn {
    left: 50px;
  }

  .pdf-viewer-next-btn {
    right: 50px;
  }

  .pdf-viewer-download-btn {
    position: absolute;
    top: 20px;
    right: 50px;
  }
}
</style>
